import $ from 'jquery';
// FIXME post-css loader? What about other options?
import '!style-loader!css-loader!sass-loader?api=modern!./global.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { IconContext } from 'react-icons';

window.jQuery = $;
window.$ = $;

import i18n from './utils/i18n';

i18n('homepage', window.selectedLocale);

import { API } from './api/index';
import { Config } from './utils/config';
import { LandingConfig } from './utils/landing/landing';
import { Experiments } from './utils/experiments';
import StylesProvider from './utils/StylesProvider';
import ThemeProvider from './utils/ThemeProvider';

import App from './components/unauthenticated/App';

// User on route change to bring back page to top
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// TODO Call MobileApp.setup()

// TODO Port and call:
/*
checkVersion = ( window, trackJs, $timeout ) ->
  appVersionFromHTML = window.version_git_hash
  appVersionFromJS = "@@VERSION_GIT_HASH@@"
  if appVersionFromHTML != appVersionFromJS
    log = "The application version from HTML (#{appVersionFromHTML}) does not match the one injected in the JS (#{appVersionFromJS})"
    console.log log
    $timeout ()->
      # Force a page relaod without cache
      location.reload( true )
 */

// TODO Port
/*
    if session.isAuthenticated()
      $analytics.setAlias( session.getUser().fullName )
      $analytics.setUsername( session.getUser().email )
      loggedIn = session.getUser().type
    else
      loggedIn = 'false';

    # logged in Google Analytics dimension
    $analytics.setUserProperties( {dimension1: loggedIn} );
 */

const dom = (
  <Router basename="/">
    <Config>
      <LandingConfig>
        <API>
          <StylesProvider>
            <Experiments>
              <ThemeProvider>
                <ScrollToTop />
                <IconContext.Provider value={{ className: 'react-icons' }}>
                  <App />
                </IconContext.Provider>
              </ThemeProvider>
            </Experiments>
          </StylesProvider>
        </API>
      </LandingConfig>
    </Config>
  </Router>
);

const root = createRoot(document.getElementById('root'));
root.render(dom);
